<style lang="scss" scoped>
  .content {
    height: calc(100% - 380px);
  }
  .fp-controlArrow{
    border-width: 16.5px0 16.5px 16px!important;
  }
  .healthheader {
      position: absolute;
      top: 0;
      z-index: 9;
    }
    .fixedBox {
    position: fixed;
    transform: translateY(-50%);
    top: 50%;
    z-index: 99;
    left: 56px;
  }
  
  .fixedli {
    border-top: 2px solid #232323;
    height: 10px;
    margin-bottom: 10px;
    width: 20px;
    cursor: pointer;
  }
  
  .activeli {
    border-top: 2px solid #1b90ef;
    height: 10px;
    width: 36px;
  }
</style>
<template>
  <div class="box">
    <Head :selectArr="selectArr" :openArr="openArr"></Head>
    <div class="content">
      <full-page :options="options" ref="page">
        <!--      第一屏-->
        <div class="section">
          <div class="box1">
            <div class="slide">
              section1
            </div>
            <div class="slide">
              section11
            </div>
            <div class="slide">
              section111
            </div>
          </div>
        </div>
        <!--      第二屏-->
        <div class="section">
          <div class="slide">
            section2
          </div>
          <div class="slide">
              section11
            </div>
            <div class="slide">
              section111
            </div>
        </div>
        <div class="section">
          <div class="box3">
            section3
          </div>
        </div>
      </full-page>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
  import Head from '../components/headercontent'
  import Foot from '../components/footercontent'
  import Service from '../common/service'
  import Store from '../vuex/index'
  export default {
    name: 'home',
    data() {
      return {
        bannerurl: '',
        dotPosition: 'center',
        options: {
          sectionsColor: ['#41b883', '#ff5f45', '#0798ec', '#fec401', '#1bcee6', ], //为每个section设置背景色
          resize: true,//字体是否随着窗口缩放而缩放
          //           scrollingSpeed: 700,//页面滚动速度
          anchors: ["page1", "page2", "page3"], //定义锚链接，通过URL 用户可以快速打开定位到某一页面；不要和页面中任意的id和name相同
          lockAnchors: true, //是否锁定锚链接
          css3: true, //是否使用css3 transform来实现滚动效果
          //           loopTop: true,//滚动到最顶部后是否连续滚动到底部
          //           loopBottom: true,//滚动到最底部后是否连续滚动到顶部
          loopHorizontal: true, //横向slide幻灯片是否循环滚动
          //           autoScrolling: false,//是否使用插件滚动方式，设为false后，会出现浏览器自带的滚动条，将不会按页滚动
          //           scrollBar: true,//是否包含滚动条，设为true，则浏览器自带的滚动条会出现，页面还是按页滚动，但是浏览器滚动条默认行为也有效
          paddingTop: "90px", //设置每个section顶部的padding，当我们要设置一个固定在顶部的菜单、导航、元素等时使用
          //          marginBottom: "300px",//设置每个section底部的padding，当我们要设置一个固定在底部的菜单、导航、元素等时使用
//                     fixedElements: ".healthheader",//固定的元素，为jquery选择器；可用于顶部导航等
          //           touchSensitivity: 5,//在移动设置中页面敏感性，最大为100，越大越难滑动
          //           animateAnchor: false,//设为false，则通过锚链接定位到某个页面不再有动画效果
          recordHistory: false, //是否记录历史，可以通过浏览器的前进后退来导航
//                     menu: '.fixedli',//绑定菜单，设定相关属性和anchors的值对应后，菜单可以控制幻灯片滚动
          "navigation": true, //是否显示导航，默认为false
          navigationPosition: 'left', //导航小圆点的位置
//        navigationTooltips: ['page1', 'page2', 'page3', 'page4', 'page5'], //鼠标移动到小圆点上时显示出的提示信息
          //           showActiveTooltip: true,//是否显示当前页面小圆点导航的提示信息，不需要鼠标移上
          controlArrows: true, //用来控制slide幻灯片的箭头，设置为false             
          scrollOverflow: false, //内容超过满屏时是否显示滚动条，需要jquery.slimscroll插件
          sectionSelector: ".section", //section选择器
          slideSelector: ".slide", //slide选择器
          licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
          afterLoad: this.afterLoad,
          keyboardScrolling: false, //是否可以使用键盘方向键导航，默认为true
          continuousVertical: false, /// 是否循环滚动，默认为false。如果设置为true，则页面会循环滚动，而不像loopTop或loopBottom那样出现跳动，注意这个属性和loopTop、loopBottom不兼容和，不要同时设置
        },
        selectArr: ['home'],
        openArr: [],
        imgdata1: [],
        imgdata2: [],
        imgdata3: [],
        imgdata4: [],
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      click() {
        // vue调用fullpapge的方法
        this.$refs.page.api.moveSectionDown();
        // moveSectionDown();
      },
      afterLoad(anchorLink, index) {
        this.activeid = parseInt(index.index) + 1;
        if(this.activeid == 3) {
          Store.commit("setIsFixed", true);
        } else {
          Store.commit("setIsFixed", false);
        }
      },
      getbanner(id) {
        Service.banner().getbanner({}, id).then(response => {
          if(id != 5) {
            this[`imgdata${id}`] = response.data;
            this.$nextTick(() => {
              var mySwiper = new Swiper(".swiper-container", {
                slidesPerView: 'auto',
                // 如果需要前进后退按钮
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
              });
            })
          } else {
            this.bannerurl = response.data[0].imgUrl
          }

        }, err => {
          console.log(err);
        });
      },
    },
    beforeDestroy() {
       Store.commit("setIsFixed", false);
    },
    components: {
      Head,
      Foot,
    },
  }
</script>


// WEBPACK FOOTER //
// src/views/newhome.vue